'use client';

import { useTranslation } from 'react-i18next';
import { HiChevronRight } from 'react-icons/hi';

import { dashboardUrl } from '@/src/utils';

export const SubFooter = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center space-y-6 bg-gradient-to-b from-transparent via-[#F2FAFF] to-transparent px-6 py-10 md:flex-row md:space-x-10 md:space-y-0 md:px-20">
      {/* Left Side Content */}
      <div className="max-w-md md:w-1/2">
        <h3 className="w-full font-rubik text-[36px] font-medium leading-[135%] tracking-[-0.01em] text-[#3D3E40] md:w-[452px]">
          {t('AbleSpace - IEP Goal Tracking App')}
        </h3>
        <p className="mt-2 w-full font-rubik text-[18px] font-normal leading-[155%] tracking-[0] text-[#3D3E40] md:w-[441px]">
          {t(
            'AbleSpace simplifies IEP management with powerful tools designed for educators and therapists.'
          )}
        </p>
        <a
          href={`${dashboardUrl}/signup`}
          className="mt-6 inline-flex h-[62px] max-w-[220px] items-center justify-between gap-[2px] rounded-lg border-2 border-[#318AE5] bg-[#318AE5] px-6 py-4 text-white"
        >
          <div className="flex items-center gap-1">
            <p className="font-rubik md:text-lg">{t('Sign Up for Free')}</p>
            <HiChevronRight size={24} />
          </div>
        </a>
      </div>

      {/* Right Side Image */}
      <div className="md:w-1/3">
        <img
          className="w-full max-w-lg bg-white"
          src="/images/blog/sub-footer.svg"
          alt="Sub Footer Illustration"
        />
      </div>
    </div>
  );
};
